
/**
 * Validate username.
 */

export function validateUsername (validity, el) {
  if (validity.valueMissing) {
    return 'Please enter a username.  Be sure they have write access so we can load your data!'
  }
  return el.validationMessage
}

/**
 * Validate password.
 */

export function validatePassword (validity, el) {
  if (validity.valueMissing) {
    return 'Please enter the password for the user who has write access.'
  }
  return el.validationMessage
}

/**
 * Validate hostname.
 */

export function validateHost (validity, el) {
  if (validity.valueMissing) {
    return 'Please enter the host where your database lives.'
  }
  return el.validationMessage
}

/**
 * Validate database name.
 */

export function validateDatabaseName (validity, el) {
  if (validity.valueMissing) {
    return 'Please enter the name of the database we should write to.'
  }
  return el.validationMessage
}

/**
 * Validate port.
 */

export function validatePort (validity, el) {
  if (validity.valueMissing) {
    return 'Please enter a port.'
  }
  if (validity.patternMismatch) {
    return 'Port must be a number.'
  }
  return el.validationMessage
}



// WEBPACK FOOTER //
// ./pages/workspace-warehouses/utils/validators.js